import { assignIfExists } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { findWithUUID, removeItemByUUID } from '@/utils/uuidHelper';
import actions from '../../constants';
import { findUserGroups } from './state';

const updateUsers = (users, { results }) => {
  users.forEach((user) => {
    const match = findWithUUID(results, user.uuid);
    if (match) {
      assignIfExists(match, user);
    }
  });
};

const updateAllUsers = ({ items }, draft) => {
  updateUsers(items, draft.userGroups.assign.users);
  ['open'].forEach((category) => {
    const { results } = draft.userGroups[category];
    results.forEach(({ users }) => { updateUsers(items, users); });
  });
};

const archiveUsersSuccess = withDraft((draft, action) => { updateAllUsers(action, draft); });

const updateUserApprovedSuccess = withDraft((draft, { code, approved }) => {
  updateAllUsers({ items: [{ uuid: code, approved }] }, draft);
});

const clearUsersGroups = withDraft((draft, { code }) => {
  const item = findUserGroups(draft, { user: { uuid: code }, category: 'assign' });
  item.users.results = removeItemByUUID(item.users.results, code);
});

export default {
  [actions.ARCHIVE_USERS_SUCCESS]: archiveUsersSuccess,
  [actions.CLOSE_USER]: clearUsersGroups,
  [actions.UPDATE_USER_APPROVED_SUCCESS]: updateUserApprovedSuccess,
};
